var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJoin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 32,
    viewBox: "0 0 23 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "n5cbhwn94a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 621",
    style: {
      fill: "none"
    },
    d: "M0 0h23v32H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 332"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 249",
    style: {
      clipPath: "url(#n5cbhwn94a)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 400",
    d: "M21.756 20.758a10.4 10.4 0 1 1-10.4-10.311 10.358 10.358 0 0 1 10.4 10.311",
    transform: "translate(-.1 -.247)",
    style: {
      fill: "#fff"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 401",
    d: "M13.482 22.721a.74.74 0 0 1-.743-.737v-1.84a.743.743 0 0 1 1.486 0v1.841a.74.74 0 0 1-.743.737"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 402",
    d: "M16.082 21.616a.74.74 0 0 1-.743-.737v-1.84a.743.743 0 0 1 1.486 0v1.841a.74.74 0 0 1-.743.737"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 403",
    d: "M6.4 23.635c.727.657 1.042 1.486.707 1.85s-1.2.129-1.924-.528-1.043-1.486-.707-1.85 1.2-.129 1.924.528",
    transform: "translate(-.175 -.631)",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 404",
    d: "M6.777 26.675c.727.657 1.043 1.486.707 1.85s-1.2.129-1.924-.528-1.043-1.486-.707-1.85 1.2-.129 1.924.528",
    transform: "translate(-.183 -.725)",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 405",
    d: "M10.2 26.675c.727.657 1.043 1.486.707 1.85S9.7 28.654 8.979 28s-1.043-1.486-.707-1.85 1.2-.129 1.924.528",
    transform: "translate(-.259 -.725)",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 406",
    d: "m6.269 2.421 3.715 6.26 4.087-6.629A5.755 5.755 0 0 0 9.984.948c-2.229.368-3.715.737-3.715 1.473",
    transform: "translate(-.217 .047)",
    style: {
      fill: "#00dd4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 407",
    d: "M11.424 9.206c-.156 0-.309.016-.465.023v-.391c.016-.023.036-.041.05-.065L14.451 2.7a.73.73 0 0 0 .067-.164 1.141 1.141 0 0 0 .153-.566C14.67.515 12.131 0 9.955 0S5.239.515 5.239 1.967a1.135 1.135 0 0 0 .154.565.736.736 0 0 0 .066.164L8.9 8.789a1.211 1.211 0 0 0 .2.256v.4a11.438 11.438 0 1 0 2.322-.236M9.955 1.473a7.7 7.7 0 0 1 3.033.493 7.69 7.69 0 0 1-3.033.494 7.684 7.684 0 0 1-3.032-.494 7.693 7.693 0 0 1 3.032-.493m-2.2 2.268a12.13 12.13 0 0 0 2.2.192 12.169 12.169 0 0 0 2.2-.191l-1.88 3.318a.373.373 0 0 1-.648 0zm3.669 26.269A9.467 9.467 0 0 1 9.1 11.341v.626a.929.929 0 0 0 1.857 0v-.9c.155-.007.308-.023.465-.023a9.482 9.482 0 1 1 0 18.964",
    transform: "translate(-.079 .074)",
    style: {
      fill: "#1a1e27"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 408",
    d: "M14.899 26.219a2.16 2.16 0 0 1-.768-.142 2.375 2.375 0 0 1-1.431-1.6.735.735 0 0 1 .511-.909.745.745 0 0 1 .918.507.918.918 0 0 0 .532.627.662.662 0 0 0 .6-.065c.23-.144.447-.28.447-1.18a.743.743 0 0 1 1.486 0 2.494 2.494 0 0 1-1.138 2.424 2.186 2.186 0 0 1-1.16.337"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJoin);
export default __webpack_public_path__ + "static/media/join.953722dce5a87f1b98a470173215186d.svg";
export { ForwardRef as ReactComponent };